import React, { Component } from 'react';
import { ThemeProvider } from '@mui/material/styles';

import { Navigate, Route, Routes } from 'react-router-dom';
import { withRouter } from '../util/withRouter';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import '../assets/vendors/style';
import AppLocale from '../lngProvider';
import { getThemeForColor } from '../utils/themeUtils';

import MainApp from '../app/index';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ShareRide from './Share-Ride';
import { setInitUrl } from '../actions/Auth';
import RTL from '../util/RTL';
import asyncComponent from '../util/asyncComponent';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const RestrictedRoute = ({ authUser, element }) => {
  return authUser ? element : <Navigate to="/signin" replace />;
};

class App extends Component {
  componentDidMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.location.pathname);
    }
  }

  // Theme selection delegated to utils/themeUtils.js

  render() {
    const { location, themeColor, isDarkTheme, locale, authUser, initURL, isDirectionRTL } =
      this.props;

    const applyTheme = getThemeForColor(themeColor, isDarkTheme);
    if (isDarkTheme) {
      document.body.classList.add('dark-theme');
    }

    // Handle root path redirects
    if (location.pathname === '/') {
      if (authUser === null) {
        return <Navigate to="/signin" replace />;
      } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
        return <Navigate to="/app/dashboard/index" replace />;
      } else {
        return <Navigate to={initURL} replace />;
      }
    }

    if (isDirectionRTL) {
      applyTheme.direction = 'rtl';
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
      applyTheme.direction = 'ltr';
    }

    const currentAppLocale = AppLocale[locale.locale];

    return (
      <ThemeProvider theme={applyTheme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
            <RTL>
              <div className="app-main">
                <Routes>
                  <Route
                    path="/app/*"
                    element={<RestrictedRoute authUser={authUser} element={<MainApp />} />}
                  />
                  <Route path="/signin" element={<SignIn />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/share-ride/:id" element={<ShareRide />} />
                  <Route
                    path="*"
                    element={React.createElement(
                      asyncComponent(() => import('../app/routes/extraPages/routes/404'))
                    )}
                  />
                </Routes>
              </div>
            </RTL>
          </IntlProvider>
        </LocalizationProvider>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { themeColor, sideNavColor, darkTheme, locale, isDirectionRTL } = settings;
  const { authUser, initURL } = auth;
  return {
    themeColor,
    sideNavColor,
    isDarkTheme: darkTheme,
    locale,
    isDirectionRTL,
    authUser,
    initURL,
  };
};

export default withRouter(connect(mapStateToProps, { setInitUrl })(App));
